import { ProductOrder } from '@cdaas/api-clients/dist/order-openapi';
import { LocalBundleEnvelope, UrlImage, BundleImage } from '@cdaas/api-clients/dist/product-service-openapi';

export const getOrderPriceText = (order: ProductOrder, month: string): string => {
  const price = order.packages?.[0]?.prices?.length ? order.packages[0].prices[0].price.total : '';
  const currency = order.packages?.[0]?.prices?.length ? order.packages[0].prices[0].price.currency : '';
  const period = order.packages[0].leasing_period ?? '';
  return `${price} ${currency}/${month} (${period} ${month})`;
};

export const isSelectedBundleAvailable = (bundle: LocalBundleEnvelope | null, chosenMainItemVariantId?: number): boolean => {
  if (!bundle || !chosenMainItemVariantId) {
    return false;
  }
  const bundleToCheck = bundle.bundle;
  const chosenVariant = (bundle.bundle.main_item.variants || []).find(variant => variant.id === chosenMainItemVariantId);
  if (!bundleToCheck || !chosenVariant?.available_amount || chosenVariant.available_amount < 1) {
    return false;
  }
  for (const addonItem of bundleToCheck.items) {
    if (!addonItem.options[0]?.available_amount || addonItem.options[0]?.available_amount < 1) {
      return false;
    }
  }
  return true;
};

export const getProductFirstImage = (allImages: UrlImage[] = [], productImageIds: number[] = []): string | undefined => {
  for (const productImageId of productImageIds) {
    const foundImage = allImages.find(image => image.id === productImageId);
    if (foundImage) return foundImage.full_size_url;
  }
  return '';
};

// expect all images to be BundleImage at this point
export const getProductAllImages = (productImageIds: number[] = [], images: UrlImage[] | BundleImage[] = []): BundleImage[] => {
  const allImages = [];
  for (const id of productImageIds) {
    allImages.push(...(images as BundleImage[]).filter(image => image.id === id));
  }
  return allImages;
};

export const NUMBER_OF_PRODUCT_PER_PAGE = 12;
